import type { AppShellDesktopConfiguration } from "../../../../../../shared/frontend/layout/AppShellDesktop";
import { useI18n } from "../i18n/useI18n";
import { notifyDesktopInteractionBlocked } from "./m1Desktop";
import { desktopTitlebarIconSrc, openDesktopAppMenu, subscribeDesktopAppMenuClosed, desktopIsWindowMaximized, subscribeDesktopWindowMaximize, desktopMinimizeWindow, desktopToggleMaximizeWindow, desktopCloseWindow, desktopUsesHtmlCaptionButtons } from "./m1Desktop";
export function useDesktopChromeConfiguration(): AppShellDesktopConfiguration {
  const { text, tr } = useI18n();
  return {
    notifyInteractionBlocked: notifyDesktopInteractionBlocked,
    menu: { title: tr("m1member"), icon: desktopTitlebarIconSrc(), label: text("Open window menu"), open: openDesktopAppMenu, subscribeClosed: subscribeDesktopAppMenuClosed },
    caption: desktopUsesHtmlCaptionButtons() ? {
      isMaximized: desktopIsWindowMaximized, subscribeMaximized: subscribeDesktopWindowMaximize, minimize: desktopMinimizeWindow, toggleMaximize: desktopToggleMaximizeWindow, close: desktopCloseWindow,
      labels: { minimize: text("Minimize window"), maximize: text("Maximize window"), restore: text("Restore window"), close: text("Close window") }, hostAttributes: { "data-m1desktop-caption": "spa" }
    } : undefined
  };
}
